const BASE_API = require("./prod.env");
export async function saveRequisition(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function userData(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form/user`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function curd(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getuserdata(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form/user`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getAllProduct(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getAllsavedRequisitionLine(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function deleteRequisitionLine(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function saveRequisitionLine(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function updateRequisitionLine(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function deleteLead(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getAll(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function loginpage(data) {
  console.log(data);
  const response = await fetch(BASE_API.NODE_ENV + `/authenticate`, {
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getData() {
  const response = await fetch(BASE_API.NODE_ENV + `/form/user`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
      "Content-Type": "text/plain",
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getOrg() {
  const response = await fetch(BASE_API.NODE_ENV + `/form/user`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getRequsition(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getRequisitionDocID(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function vesselInfo(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function updateRequisition(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getLogo(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form/readfile`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function completeRequisition(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form/processRequisition`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getVessellists(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getCertificateType(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getCertificate(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function saveCertificates_Expiry(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getVesselCertificate(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function updateCertificateAttachment(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getAttachment(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form/readfile`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function deleteAttachment(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form/writefile`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getVesselExpiryDate(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getvesselMaster(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function saveDailyProgress(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function saveEveryHourActivity(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getMainEngineWithFuel(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getMainEngineFuel(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function saveMainEngineRHS(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function saveMainEngineConsumption(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function updateME(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getROBCommodityList(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function saveROBCommodity(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getOtherEngineList(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function SaveOtherEngineConsumption(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function SaveWeather(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function SaveTides(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function SaveDownTime(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function SavePOB(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function saveSunbeam(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getSafetyCheck(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function SaveSafetyCheck(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getVesselEquipments(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getAllSubmitedDPR(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getUserVesselExpiry(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getUserVesselMaster(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getCrewInfo(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function completePMSStatus(data) {
  const response = await fetch(BASE_API.NODE_ENV + `/form`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")),
    },
    body: JSON.stringify(data),
  });
  return await response.json();
}
export async function getOTP(data) {
  const response = await fetch(BASE_API.NODE + `/Validation/verifyOTP`, {
    method: "POST",
    body: JSON.stringify(data),
  });
  return await response.json();
}



// WEBPACK FOOTER //
// ./src/components/service/CallWebService.js